import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'
import { Turbo } from "@hotwired/turbo-rails"
import { load_more_timeline_path } from "../routes"
import { I18n } from 'i18n-js'
import locales from '../locales.json'

export default class extends Controller {
  static values = {
    resourceType: String,
    resourceId: Number,
    offset: Number
  }
  static targets = ["loadMoreButton"]

  connect() {
    // Initialize i18n
    this.i18n = new I18n(locales)
    this.i18n.locale = document.querySelector("meta[name='locale']")?.content || 'en'
  }

  async loadMore(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const originalText = button.textContent
    
    // Disable button and show loading state
    button.disabled = true
    button.textContent = this.i18n.t('audit_events.loading')
    
    try {
      const formData = new FormData()
      formData.append('resource_type', this.resourceTypeValue)
      formData.append('resource_id', this.resourceIdValue)
      formData.append('offset', this.offsetValue)
      
      const request = new FetchRequest(
        "post",
        load_more_timeline_path(),
        {
          body: formData,
          responseKind: "turbo-stream"
        }
      )
      
      const response = await request.perform()
      
      if (response.ok) {
        // FetchRequest response.text is a getter, not a function
        const body = await response.text
        Turbo.renderStreamMessage(body)
        // Update the offset value from the button's data attribute after DOM update
        // The next_offset is set by the server in the turbo stream response
        setTimeout(() => {
          const updatedButton = this.loadMoreButtonTarget
          if (updatedButton) {
            const newOffset = updatedButton.dataset.timelineOffsetValue
            if (newOffset) {
              this.offsetValue = parseInt(newOffset)
            }
          }
        }, 0)
      } else {
        console.error("[timeline_controller] Failed to load more timeline items.")
        button.textContent = originalText
        button.disabled = false
      }
    } catch (error) {
      console.error("[timeline_controller] Error loading more timeline items:", error)
      button.textContent = originalText
      button.disabled = false
    }
  }
}

